interface ColorItemType {
  group: string;
  color: string;
  name: string;
  trim?: boolean;
}

enum ColorGroups {
  POPULAR = 'Popular',
  WHITE = 'Whites',
  GRAY = 'Grays',
  BROWN = 'Browns',
  RED = 'Reds',
  ORANGE = 'Oranges',
  YELLOW = 'Yellows',
  GREEN = 'Greens',
  BLUE = 'Blues',
  PURPLE = 'Purples',
}

enum JhColorGroups {
  MAGNOLIA = 'Magnolia',
  STATEMENT = 'Statement',
  DREAM = 'Dream',
}

const BASE_WHITE_HEX_CODE = '#ffffff';

const ColorGroupLabelColors: { [key: string]: string } = {};
ColorGroupLabelColors[ColorGroups.WHITE] = '#ffffff';
ColorGroupLabelColors[ColorGroups.GRAY] = '#808183';
ColorGroupLabelColors[ColorGroups.BROWN] = '#996633';
ColorGroupLabelColors[ColorGroups.RED] = '#E44B3A';
ColorGroupLabelColors[ColorGroups.ORANGE] = '#F37500';
ColorGroupLabelColors[ColorGroups.YELLOW] = '#FCEC00';
ColorGroupLabelColors[ColorGroups.GREEN] = '#00A850';
ColorGroupLabelColors[ColorGroups.BLUE] = '#1472A5';
ColorGroupLabelColors[ColorGroups.PURPLE] = '#B933AD';

const Colors = [
  { group: ColorGroups.POPULAR, color: '#ffffff', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#d6cab9', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#e9d5c9', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#c8e2cc', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#e9e4da', name: ColorGroups.YELLOW },
  { group: ColorGroups.POPULAR, color: '#ddb582', name: ColorGroups.ORANGE },
  { group: ColorGroups.POPULAR, color: '#c39c83', name: ColorGroups.RED },
  { group: ColorGroups.POPULAR, color: '#b8cccd', name: ColorGroups.BLUE },
  { group: ColorGroups.POPULAR, color: '#b0b9a6', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#bba088', name: ColorGroups.ORANGE },
  { group: ColorGroups.POPULAR, color: '#9d8376', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#147d87', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#719ca4', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#d39952', name: ColorGroups.ORANGE },
  { group: ColorGroups.POPULAR, color: '#9f5440', name: ColorGroups.RED },
  { group: ColorGroups.POPULAR, color: '#7b90a2', name: ColorGroups.BLUE },
  { group: ColorGroups.POPULAR, color: '#87857e', name: ColorGroups.GRAY },
  { group: ColorGroups.POPULAR, color: '#a76944', name: ColorGroups.ORANGE },
  { group: ColorGroups.POPULAR, color: '#7f576d', name: ColorGroups.RED },
  { group: ColorGroups.POPULAR, color: '#344d58', name: ColorGroups.BLUE },
  { group: ColorGroups.POPULAR, color: '#5f6d59', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#434442', name: ColorGroups.GRAY },
  { group: ColorGroups.WHITE, color: '#ffffff', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#f1ede0', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#e8ddca', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#f5f4ec', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#ebebe6', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#ebdec4', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#e7e2d2', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#f7edd8', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#eff0ec', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#f3e9d6', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#e5dfd2', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#e5e2da', name: ColorGroups.WHITE },
  { group: ColorGroups.WHITE, color: '#eeebe2', name: ColorGroups.WHITE },
  { group: ColorGroups.GRAY, color: '#d9d9d2', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#999d9e', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#c5c5c3', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#acb0b0', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#b6b9b6', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#cfd2d3', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#aeadac', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#cccfcb', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#cbcecd', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#d1d1cf', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#757574', name: ColorGroups.GRAY },
  { group: ColorGroups.GRAY, color: '#c0c4c6', name: ColorGroups.GRAY },
  { group: ColorGroups.BROWN, color: '#a68a71', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#d5c9bc', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#cab095', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#ddc5af', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#dec7ad', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#a69c91', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#dad3cb', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#e9d6bd', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#e1d0be', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#d3c5af', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#e3ded4', name: ColorGroups.BROWN },
  { group: ColorGroups.BROWN, color: '#5a4840', name: ColorGroups.BROWN },
  { group: ColorGroups.RED, color: '#f6d8d2', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#c89697', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#dd84a3', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#744e5b', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#e1887f', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#cb5c5b', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#a04039', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#843c41', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#c49d93', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#d04838', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#be3c37', name: ColorGroups.RED },
  { group: ColorGroups.RED, color: '#744543', name: ColorGroups.RED },
  { group: ColorGroups.ORANGE, color: '#f39d71', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#e36940', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#da5736', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#af6649', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#eec2ad', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#f39233', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#ea7739', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#d2864e', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#eadbc9', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#f5d8ba', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#dabe9f', name: ColorGroups.ORANGE },
  { group: ColorGroups.ORANGE, color: '#c39c83', name: ColorGroups.ORANGE },
  { group: ColorGroups.YELLOW, color: '#feebc8', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#f2dfb5', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#ffe487', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#ffca46', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#eaddc6', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#fcdba6', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#e6c17a', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#ffb729', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#f7e7cd', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#f5d6aa', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#d2ba9d', name: ColorGroups.YELLOW },
  { group: ColorGroups.YELLOW, color: '#c79e73', name: ColorGroups.YELLOW },
  { group: ColorGroups.GREEN, color: '#d7d9c2', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#bdb98f', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#aaa794', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#72754f', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#d3d9d0', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#96a782', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#698538', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#5a6952', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#b4cccb', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#87d9d2', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#859893', name: ColorGroups.GREEN },
  { group: ColorGroups.GREEN, color: '#596d69', name: ColorGroups.GREEN },
  { group: ColorGroups.BLUE, color: '#acdbdb', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#65c3d6', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#1cadba', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#60818e', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#d7e8ec', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#9ab6c0', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#8d99a1', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#679bb3', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#9ac1dc', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#70869d', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#267ebc', name: ColorGroups.BLUE },
  { group: ColorGroups.BLUE, color: '#40495b', name: ColorGroups.BLUE },
  { group: ColorGroups.PURPLE, color: '#d7d0e1', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#c1c2d7', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#9097b4', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#5e5f7e', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#e1e2eb', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#87819b', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#9076ae', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#6c5d97', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#e4e5e7', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#bfb9bd', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#a29aa0', name: ColorGroups.PURPLE },
  { group: ColorGroups.PURPLE, color: '#6f5f70', name: ColorGroups.PURPLE },
];

// Once the JH trim colors are finalized this list will need to be updated with the
// final colors and the ones that can be used for trim.
const JamesHardieColors = [
  { group: JhColorGroups.MAGNOLIA, color: '#434344', name: 'Midnight Soot' },
  { group: JhColorGroups.MAGNOLIA, color: '#bcae99', name: 'Rugged Path' },
  { group: JhColorGroups.MAGNOLIA, color: '#d8cfc3', name: 'Rustic Road' },
  { group: JhColorGroups.MAGNOLIA, color: '#a9ab9e', name: 'Dried Eucalyptus' },
  { group: JhColorGroups.MAGNOLIA, color: '#4b5053', name: 'Last Embers' },
  { group: JhColorGroups.MAGNOLIA, color: '#857D72', name: 'Warm Clay' },
  { group: JhColorGroups.MAGNOLIA, color: '#aba69e', name: 'Stone Paver' },
  { group: JhColorGroups.MAGNOLIA, color: '#b6b6ad', name: "It's About Thyme" },
  { group: JhColorGroups.MAGNOLIA, color: '#6a6a61', name: 'Peppery Ash' },
  { group: JhColorGroups.MAGNOLIA, color: '#7e847b', name: 'Chiseled Green' },
  { group: JhColorGroups.MAGNOLIA, color: '#efe8dd', name: 'Birch Tree' },
  { group: JhColorGroups.MAGNOLIA, color: '#80827c', name: 'Slate Steps' },
  { group: JhColorGroups.MAGNOLIA, color: '#bdb8ae', name: 'Stone Beach' },
  { group: JhColorGroups.MAGNOLIA, color: '#e7dfd4', name: 'Weathered Cliffs' },
  { group: JhColorGroups.MAGNOLIA, color: '#686456', name: 'Wandering Green' },
  { group: JhColorGroups.MAGNOLIA, color: '#726e60', name: 'Mudflats' },
  { group: JhColorGroups.STATEMENT, color: '#7b7873', name: 'Aged Pewter' },
  {
    group: JhColorGroups.STATEMENT,
    color: '#dfe0dd',
    name: 'Arctic White',
    trim: true,
  },
  { group: JhColorGroups.STATEMENT, color: '#737e83', name: 'Boothbay Blue' },
  {
    group: JhColorGroups.STATEMENT,
    color: '#c8c0b4',
    name: 'Cobble Stone',
    trim: true,
  },
  { group: JhColorGroups.STATEMENT, color: '#49515b', name: 'Deep Ocean' },
  { group: JhColorGroups.STATEMENT, color: '#5b656a', name: 'Evening Blue' },
  { group: JhColorGroups.STATEMENT, color: '#868885', name: 'Gray Slate' },
  {
    group: JhColorGroups.STATEMENT,
    color: '#525655',
    name: 'Iron Gray',
    trim: true,
  },
  { group: JhColorGroups.STATEMENT, color: '#9f8d7b', name: 'Khaki Brown' },
  { group: JhColorGroups.STATEMENT, color: '#b5b9b5', name: 'Light Mist' },
  { group: JhColorGroups.STATEMENT, color: '#a1998a', name: 'Monterey Taupe' },
  { group: JhColorGroups.STATEMENT, color: '#6d6b58', name: 'Mountain Sage' },
  { group: JhColorGroups.STATEMENT, color: '#d4c9b4', name: 'Navajo Beige' },
  { group: JhColorGroups.STATEMENT, color: '#67696c', name: 'Night Gray' },
  { group: JhColorGroups.STATEMENT, color: '#b2aeab', name: 'Pearly Gray' },
  {
    group: JhColorGroups.STATEMENT,
    color: '#776d60',
    name: 'Timber Bark',
    trim: true,
  },
  { group: JhColorGroups.STATEMENT, color: '#6c4641', name: 'Countrylane Red' },
  { group: JhColorGroups.STATEMENT, color: '#5c5653', name: 'Rich Espresso' },
  {
    group: JhColorGroups.STATEMENT,
    color: '#f4f1e8',
    name: 'Midnight Black',
    trim: true,
  },
  { group: JhColorGroups.DREAM, color: '#404448', name: 'Black Walnut' },
  { group: JhColorGroups.DREAM, color: '#434447', name: 'Jet Black' },
  { group: JhColorGroups.DREAM, color: '#ede9e1', name: 'Snow Owl' },
  { group: JhColorGroups.DREAM, color: '#ebddc8', name: 'White Meringue' },
  { group: JhColorGroups.DREAM, color: '#896057', name: 'Brown Clay' },
  { group: JhColorGroups.DREAM, color: '#7c6f6a', name: 'Fox Hollow Gray' },
  { group: JhColorGroups.DREAM, color: '#b5b3b7', name: 'Gray Owl' },
  { group: JhColorGroups.DREAM, color: '#dcdfdc', name: 'Gull Gray' },
  { group: JhColorGroups.DREAM, color: '#bdc2b8', name: 'Leaf Dust' },
  { group: JhColorGroups.DREAM, color: '#a5a7a4', name: 'Lost in Gray' },
  { group: JhColorGroups.DREAM, color: '#d2c7c7', name: 'Luxury Lavender' },
  { group: JhColorGroups.DREAM, color: '#6d5a4a', name: 'Slumber Brown' },
  { group: JhColorGroups.DREAM, color: '#e2e0d6', name: 'White Whicker' },
  { group: JhColorGroups.DREAM, color: '#dfe9d7', name: 'First Spring' },
  { group: JhColorGroups.DREAM, color: '#668461', name: 'Front Lawn' },
  { group: JhColorGroups.DREAM, color: '#14745f', name: 'Green Acres' },
  { group: JhColorGroups.DREAM, color: '#405d54', name: 'Impreial Green' },
  { group: JhColorGroups.DREAM, color: '#236780', name: 'Out of the Blue' },
  { group: JhColorGroups.DREAM, color: '#c5e5e6', name: 'Powder Blue' },
  { group: JhColorGroups.DREAM, color: '#99c3c1', name: 'Royal Teal' },
  { group: JhColorGroups.DREAM, color: '#345477', name: 'True Blue' },
  { group: JhColorGroups.DREAM, color: '#ddc8aa', name: 'Baked Biscuit' },
  { group: JhColorGroups.DREAM, color: '#a18161', name: 'Nut Brown' },
  { group: JhColorGroups.DREAM, color: '#915146', name: 'Rustic Ranch' },
  { group: JhColorGroups.DREAM, color: '#f3e2ca', name: 'Whipped Cream' },
];

// All Magnolia and Dream colors are available as trim colors
// but only certain Statement colors are, as indicated by the trim property
const JamesHardieTrimColors = JamesHardieColors.filter(
  color =>
    color.group === JhColorGroups.MAGNOLIA ||
    color.group === JhColorGroups.DREAM ||
    color.trim,
);

const WindowColors = [
  { group: ColorGroups.POPULAR, color: '#ffffff', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#8c9091', name: ColorGroups.GRAY },
  { group: ColorGroups.POPULAR, color: '#606060', name: ColorGroups.GRAY },
  { group: ColorGroups.POPULAR, color: '#464b4c', name: ColorGroups.GRAY },
  { group: ColorGroups.POPULAR, color: '#83301e', name: ColorGroups.RED },
  { group: ColorGroups.POPULAR, color: '#c5865b', name: ColorGroups.ORANGE },
  { group: ColorGroups.POPULAR, color: '#6b6054', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#3a2b18', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#a39787', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#9a8e7e', name: ColorGroups.BROWN },
  { group: ColorGroups.POPULAR, color: '#cdbea9', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#ebdfc8', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#f6ebcf', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#d5caa9', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#f4f1e8', name: ColorGroups.WHITE },
  { group: ColorGroups.POPULAR, color: '#353734', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#355442', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#0f5e41', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#1d4237', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#053207', name: ColorGroups.GREEN },
  { group: ColorGroups.POPULAR, color: '#264b50', name: ColorGroups.BLUE },
  { group: ColorGroups.POPULAR, color: '#000000', name: 'Black' },
];

export {
  Colors,
  ColorItemType,
  ColorGroups,
  ColorGroupLabelColors,
  JhColorGroups,
  JamesHardieColors,
  JamesHardieTrimColors,
  WindowColors,
  BASE_WHITE_HEX_CODE,
};
